module.exports = __webpack_public_path__ + "static/media/part-return-slide-5.cfc96223.jpg";